module.exports = __webpack_public_path__ + "static/img/Jacob-Liddle.c0cfefb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jacob-Liddle.jpg
// module id = go15
// module chunks = 0